import axios, { AxiosInstance, RawAxiosRequestConfig } from 'axios';
import { BaseAPI } from './generated/base';
import { Configuration } from './generated/configuration';

declare const WEB_COMPONENT_NAME: string;

export interface ApiConfigParams {
    basePath: string;
}

export type BaseApiConstructor<T> = new (
    config: Configuration,
    basePath?: string,
    axios?: AxiosInstance
) => T;

export const API_AXIOS = axios.create();

API_AXIOS.interceptors.request.use(config => {
    config.headers['X-TaskHub-Source-URL'] = window.location.href;

    if (typeof WEB_COMPONENT_NAME !== 'undefined') {
        config.headers['X-TaskHub-MFE'] = WEB_COMPONENT_NAME;
    }

    return config;
});

export const createApiConfig = (params: ApiConfigParams): Configuration =>
    new Configuration({
        basePath: params.basePath,
        baseOptions: {
            withCredentials: true,
            headers: {
                'X-CSRF': '1',
            },
        },
    });

export const createApiClient = <T extends BaseAPI>(
    Api: BaseApiConstructor<T>,
    config: Configuration
): T => new Api(config, undefined, API_AXIOS);

export const buildOptionsWithContextConfigTrackingHeader = (
    contextConfigId: string | undefined,
    otherOptions: RawAxiosRequestConfig = {}
): RawAxiosRequestConfig => {
    const options: RawAxiosRequestConfig = { ...otherOptions };

    if (contextConfigId) {
        options.headers = {
            ...options.headers,
            'X-TaskHub-Context-Config-ID': contextConfigId, // Used to track source of the request in back end logs
        };
    }

    return options;
};
